export default "__VITE_ASSET__XkQ2BXTY__"